<template>
  <div style="padding: 10px">
    <!--搜索区域-->
    <div style="margin: 10px 0">
      <el-input v-model="search.clubName" placeholder="请输入俱乐部名称" @keyup.enter.native="load" style="width: 20%"
                clearable></el-input>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column label="操作" width="80px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="clubName"
          label="俱乐部名称">
      </el-table-column>
      <el-table-column
          prop="clubId"
          label="俱乐部ID">
      </el-table-column>
      <el-table-column
          prop="accountName"
          label="团长">
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <!--新增编辑表单-->
    <el-dialog title="新增/编辑" v-model="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="俱乐部名称">
          <el-input v-model="form.clubName" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="人数上限">
          <el-input type="number" v-model="form.maxCount" style="width: 80%" @keyup.enter.native="save"></el-input>
        </el-form-item>
        <el-form-item label="团长">
          <!-- 修改为可搜索的选择框 -->
          <el-select
              v-model="form.leaderId"
              placeholder="团长"
              filterable
              remote
              clearable
              :remote-method="handleSearchAccountInfo"
              :loading="searchAccountLoading"
              @focus="handleAccountSelectFocus"
          >
            <el-option
                v-for="item in accountInfoOptions"
                :key="item.roleId"
                :label="item.accountName"
                :value="item.roleId"
            >
              <span>{{ item.accountName }} ({{ item.roleId }})</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import request from "@/utils/request";

export default {
  name: 'clubInfo',
  components: {},
  data() {
    return {
      exportUrl: "http://localhost:9090/clubInfo/exportSource",
      clubCodeDict: [],
      inUseDict: [{"value": 1, "label": "是"}, {"value": 0, "label": "否"}],
      // 修改为动态搜索的数据结构
      accountInfoOptions: [], // 用于存储搜索到的账号列表
      searchAccountLoading: false, // 搜索加载状态
      dialogVisible: false,
      form: {},
      formSource: {},
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 防抖计时器
      searchAccountDebounce: null
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
    this.getClubCodeDict()
    // 移除 getAccountInfoList() 调用
  },
  methods: {
    // 处理账号搜索
    handleSearchAccountInfo(query) {
      this.searchAccountLoading = true;

      // 清除之前的防抖计时器
      if (this.searchAccountDebounce) {
        clearTimeout(this.searchAccountDebounce);
      }

      // 设置新的防抖计时器
      this.searchAccountDebounce = setTimeout(() => {
        this.performSearchAccount(query);
      }, 300);
    },

    // 实际执行搜索
    performSearchAccount(keyword) {
      request.get("/accountInfo/searchAccounts", {
        params: {
          accountName: keyword,
          limit: 20
        }
      }).then(res => {
        this.searchAccountLoading = false;
        if (res.code === '0') {
          this.accountInfoOptions = res.data;
        } else {
          this.accountInfoOptions = [];
        }
      }).catch(error => {
        this.searchAccountLoading = false;
        console.error('搜索账号失败:', error);
        this.accountInfoOptions = [];
      });
    },

    // 选择框获得焦点时的处理
    handleAccountSelectFocus() {
      // 如果还没有数据，自动搜索前20条记录
      if (this.accountInfoOptions.length === 0) {
        this.handleSearchAccountInfo('');
      }
    },

    getClubCodeDict() {
      request.get("/clubInfo/listNoPageForWeb", {}).then(res => {
        this.clubCodeDict = res.data
      })
    },
    // 点击新增按钮
    add() {
      this.dialogVisible = true
      this.form = {}
    },
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },
    save() {
      this.loading = true;
      if (this.form.id) {  // 更新
        request.post("/clubInfo/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: "更新成功"
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.load() // 刷新表格的数据
          this.loading = false
          this.dialogVisible = false  // 关闭弹窗
        })
      } else {  // 新增
        request.post("/clubInfo/save", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: "新增成功"
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.form = '';
          this.load(); // 刷新表格的数据
          this.loading = false
          this.dialogVisible = false  // 关闭弹窗
        })
      }
    },
    handleUploadSuccess(res) {
      if (res.code === "0") {
        this.$message.success("导入成功")
        this.load()
      }
    },
    resetData() {
      this.search = {}
      this.load()
    },
    // 数据展平并生成合并规则
    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/clubInfo/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    handleSizeChange(pageSize) {   // 改变当前每页的个数触发
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {  // 改变当前页码触发
      this.currentPage = pageNum
      this.load()
    },
    inUseFormatter(row) {
      if (row.inUse === null) {
        return "未知";
      }
      const list = this.inUseDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].value === row.inUse) {
            return list[i].label
          }
        }
      }
    },
    formatClubCode(row) {
      if (row.clubCode === null || row.clubCode === -1) {
        return "无";
      }
      const list = this.clubCodeDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].clubCode === row.clubCode) {
            return list[i].clubName
          }
        }
      }
    },
  }
}
</script>
